import { useSessionStore } from '@/entities/session';
import { getOperationsHistory } from '@/shared/api';
import { OPERATIONS_HISTORY_KEY } from '@/shared/config';
import { useAppSettingsStore } from '@/shared/lib';
import type { OperationFilter, OperationHistoryParams } from '@/shared/types';
import { objectToQueryParamsStr } from '@/shared/utils';
import { useQuery } from '@tanstack/react-query';

const useOperationsHistory = (
  filter: OperationFilter,
  params: OperationHistoryParams = {},
  enabled = true
) => {
  const { language } = useAppSettingsStore();
  const { session } = useSessionStore();
  const queryString = objectToQueryParamsStr(params as Record<string, string>);

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [
      OPERATIONS_HISTORY_KEY,
      session?.userId,
      language,
      filter,
      queryString,
    ],
    queryFn: () =>
      getOperationsHistory(queryString ? `${filter}?${queryString}` : filter),
    enabled: enabled && !!session?.userId,
    staleTime: queryString ? 0 : Infinity,
    gcTime: queryString ? undefined : Infinity,
  });

  return {
    operationsHistory: data,
    isOperationsHistoryLoading: isLoading,
    operationsHistoryError: error,
    refetchOperationsHistory: refetch,
  };
};

export { useOperationsHistory };
